import { useSnackbar } from 'notistack';
import { useMutation } from 'react-query';
import { useHistory } from 'react-router-dom';
import { ROUTES } from 'routing/routes';
import { useService } from 'shared/providers';
import { Quote, QuoteWithoutId } from 'shared/types';

export function useCreateQuote() {
  const { quoteService } = useService();
  const { enqueueSnackbar } = useSnackbar();
  const history = useHistory();
  const mutation = useMutation<Quote, Error, QuoteWithoutId>(request => quoteService.createQuote(request), {
    onSuccess: data => {
      enqueueSnackbar('Quote was created', { variant: 'success' });
      history.push(ROUTES.toQuote(data.brand, data.id));
    },
    onError: () => {
      enqueueSnackbar('Quote was not created', { variant: 'error' });
    },
  });

  return mutation;
}
